import { css } from 'lit';

export default css`
  ul {
    display: flex;
    flex-direction: column;
    gap: calc(var(--base-gap) / 4);
  }

  li {
    span {
      display: flex;
      justify-content: space-between;
    }
  }

  button {
    border: none;
    border-radius: 50%;
  }
`;
